import { type QueryHookOptions, useQuery } from '@provision/graphql-client';
import { useMemo } from 'react';
import { isNullish } from 'remeda';
import { GET_ACTIVATION_FLOW_CONFIG_QUERY } from 'src/graphql/entities/activation-flow-config/activation-flow-config.operations';
import type {
  GetActivationFlowConfigQueryData,
  GetActivationFlowConfigQueryVariables,
} from 'src/graphql/entities/activation-flow-config/activation-flow-config.types';

type UseActivationFlowConfigParams = {
  partnerId: number | null;
  brandId: string | null;
};

export const useMembershipsActivationFlowConfig = (
  { partnerId, brandId }: UseActivationFlowConfigParams,
  options?: QueryHookOptions<
    GetActivationFlowConfigQueryData,
    GetActivationFlowConfigQueryVariables
  >,
) => {
  const shouldFetchConfig =
    !isNullish(partnerId) && Boolean(brandId) && options?.skip !== true;

  const { data, loading, error, refetch } = useQuery<
    GetActivationFlowConfigQueryData,
    GetActivationFlowConfigQueryVariables
  >(GET_ACTIVATION_FLOW_CONFIG_QUERY, {
    ...options,
    fetchPolicy: options?.fetchPolicy ?? 'no-cache',
    nextFetchPolicy: options?.nextFetchPolicy ?? 'no-cache',
    variables: {
      input: {
        partnerId: String(partnerId ?? ''),
        brandId: brandId ?? '',
      },
    },
    skip: !shouldFetchConfig,
  });

  const config = useMemo(() => data?.getBundledActivationFlowConfig ?? null, [data]);

  return {
    config,
    loading,
    error,
    refetch,
  };
};
